import { jsx as t } from "react/jsx-runtime";
import o from "../GeoTag/Geotag.js";
import l from "google-map-react";
import { memo as s } from "react";
const a = process.env.GMAPS_API_KEY, r = ({ point: e }) => /* @__PURE__ */ t(
  l,
  {
    bootstrapURLKeys: { key: a },
    center: {
      lat: e.latitude,
      lng: e.longitude
    },
    yesIWantToUseGoogleMapApiInternals: !0,
    zoom: 15,
    options: {
      styles: [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [
            {
              visibility: "#on"
            }
          ]
        }
      ]
    },
    children: /* @__PURE__ */ t(o, { lat: e.latitude, lng: e.longitude })
  }
), y = s(r);
export {
  y as default
};
//# sourceMappingURL=UnitDetailsMap.js.map
